function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.6098 4.4042C42.2265 2.02086 39.0306 0.666748 35.6181 0.666748C32.2056 0.666748 29.0098 1.9667 26.6265 4.4042L4.36399 26.6667C1.98066 29.0501 0.626478 32.246 0.626478 35.6585C0.626478 39.071 1.92649 42.2669 4.36399 44.6502C6.74732 47.0335 9.94314 48.3876 13.3556 48.3876C16.7681 48.3876 19.964 47.0877 22.3473 44.6502L44.6098 22.3876C46.9931 20.0043 48.3473 16.8084 48.3473 13.3959C48.3473 9.98341 47.0473 6.78753 44.6098 4.4042ZM19.314 41.5626C17.7431 43.1334 15.6306 44.0001 13.4098 44.0001C11.189 44.0001 9.07645 43.1334 7.50562 41.5626C5.93479 39.9917 5.06812 37.8793 5.06812 35.6585C5.06812 33.4376 5.93479 31.3252 7.50562 29.7544L16.5515 20.7084C19.0432 22.3334 25.1639 26.7208 28.4139 32.5166L19.314 41.5626ZM41.5765 19.3L31.1765 29.7001C27.7098 24.121 22.1848 19.8958 19.2598 17.8916L29.714 7.43758C31.2848 5.86675 33.3973 5.00008 35.6181 5.00008C37.839 5.00008 39.9515 5.86675 41.5223 7.43758C43.0931 9.00842 43.9598 11.1209 43.9598 13.3417C43.9598 15.5625 43.1473 17.7292 41.5765 19.3ZM30.7431 12.9627C31.5015 13.721 31.5015 14.9127 30.7431 15.671L28.1431 18.2709C27.7639 18.6501 27.2764 18.8126 26.7889 18.8126C26.3014 18.8126 25.8139 18.6501 25.4348 18.2709C24.6764 17.5126 24.6764 16.3209 25.4348 15.5626L28.0348 12.9627C28.7931 12.2044 29.9848 12.2044 30.7431 12.9627ZM35.0765 8.57513C35.4556 8.9543 35.7264 9.55003 35.7264 10.0917C35.7264 10.6334 35.5098 11.2294 35.0765 11.6085C34.6973 11.9877 34.1014 12.2584 33.5598 12.2584C32.9639 12.2584 32.4223 12.0419 32.0431 11.6085C31.664 11.1752 31.3931 10.6334 31.3931 10.0917C31.3931 9.49586 31.6098 8.9543 32.0431 8.57513C32.4765 8.1418 33.0181 7.92503 33.5598 7.92503C34.1556 7.92503 34.6973 8.19597 35.0765 8.57513Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 24.4869,
  y1: 0.666748,
  x2: 24.4869,
  y2: 48.3876,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/PillIcon.2ee8ffc9.svg";
export { SvgComponent as ReactComponent };